import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Building2, UserRound, ArrowRight } from "lucide-react";
import "./DualCtaStrip.css";

export default function DualCtaStrip() {
  return (
    <section className="dual-cta">
      <div className="container">
        <div className="dual-cta__grid">
          <motion.article
            className="dual-cta__card dual-cta__card--employer"
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            data-cursor="card"
          >
            <span className="dual-cta__icon" aria-hidden="true">
              <Building2 size={20} strokeWidth={1.8} />
            </span>
            <span className="eyebrow">For Employers</span>
            <h3 className="dual-cta__title">Build your team with Adel.</h3>
            <p className="dual-cta__body">
              Tell us what you need. We&rsquo;ll find candidates, handle the
              logistics, and introduce you to people ready to perform.
            </p>
            <Link
              to="/contact"
              className="dual-cta__btn dual-cta__btn--primary"
              data-cursor="cta"
            >
              Talk to our team
              <ArrowRight size={16} strokeWidth={2} />
            </Link>
          </motion.article>

          <motion.article
            className="dual-cta__card dual-cta__card--candidate"
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{
              duration: 0.6,
              delay: 0.08,
              ease: [0.22, 1, 0.36, 1],
            }}
            data-cursor="card"
          >
            <span className="dual-cta__icon" aria-hidden="true">
              <UserRound size={20} strokeWidth={1.8} />
            </span>
            <span className="eyebrow">For Candidates</span>
            <h3 className="dual-cta__title">Apply for roles in the Gulf.</h3>
            <p className="dual-cta__body">
              Submit your profile and the roles that interest you. We&rsquo;ll
              review fit and guide you through every step to deployment.
            </p>
            <Link
              to="/job-seekers"
              className="dual-cta__btn dual-cta__btn--ghost"
              data-cursor="cta"
            >
              Submit your profile
              <ArrowRight size={16} strokeWidth={2} />
            </Link>
          </motion.article>
        </div>
      </div>
    </section>
  );
}
